// extracted by mini-css-extract-plugin
module.exports = {"container":"BackgroundImage_container__Q8TRq","logo":"BackgroundImage_logo__EpmrP"};